import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'raceResultBettingType',
})
export class RaceResultBettingTypePipe implements PipeTransform {
  transform(betName: string, betOdd: number, allRaceResults: any): any {
    // just finds race results of bet type
    let raceResults = allRaceResults.filter(
      (raceResult) => raceResult.name === betName
    );

    if (raceResults.length <= 1) {
      return betName;
    }

    if (betName === 'Quarté+ Standard' || betName === 'Tiercé Standard') {
      return betName;
    }

    // sorts(asc) race results by odds
    raceResults = raceResults.sort(
      (raceResult1, raceResult2) => raceResult1.odd - raceResult2.odd
    );
    const odds = raceResults.map((raceResult) => raceResult.odd);
    if (betName === 'Quarté+ Champ') {
      if (odds.length === 2) {
        const betIndex = odds.indexOf(betOdd) + 1;

        return betName + '_' + betIndex;
      }
    }

    const betIndex = odds.indexOf(betOdd);
    return betName + '_' + betIndex;
  }
}
